module.exports = __webpack_public_path__ + "img/swiper2.d037012.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/swiper2.png
// module id = 419
// module chunks = 0